import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import ValOrDash from "./ValOrDash";
import { Space } from "antd";
class FormattedAddressProps {
    address = null;
    companyName = null;
    contactName = null;
    contactTelephone = null;
    contactEmail = null;
    uhfChannelOffice = null;
    uhfChannelLoader = null;
}
const FormattedAddress = ({ address, companyName, contactName, contactTelephone, contactEmail, uhfChannelOffice, uhfChannelLoader }) => {
    return (_jsxs("div", { children: [address &&
                _jsxs("address", { children: [companyName && _jsxs("span", { children: [_jsx("strong", { children: companyName }), _jsx("br", {})] }), address.unitOrFlat, " ", address.street, _jsx("br", {}), address.suburb, " ", address.state, " ", address.postcode, _jsx("br", {})] }), (contactName || contactTelephone || contactEmail) &&
                _jsxs("dl", { children: [_jsx("dt", { children: "Contact Name" }), _jsx("dd", { children: _jsx(ValOrDash, { val: contactName }) }), _jsx("dt", { children: "Contact Telephone" }), _jsx("dd", { children: _jsx(ValOrDash, { val: contactTelephone }) }), _jsx("dt", { children: "Contact Email" }), _jsx("dd", { children: _jsx(ValOrDash, { val: contactEmail }) }), uhfChannelOffice || uhfChannelLoader ?
                            _jsxs(_Fragment, { children: [_jsx("dt", { children: "UHF Channels" }), _jsx("dd", { children: _jsxs(Space, { align: "start", children: [_jsxs("span", { children: ["Office: ", _jsx(ValOrDash, { val: uhfChannelOffice })] }), _jsxs("span", { children: ["Loader: ", _jsx(ValOrDash, { val: uhfChannelLoader })] })] }) })] }) : null] })] }));
};
export default FormattedAddress;
